$('.gallery-item a').on('click', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox();
});